module.exports = __webpack_public_path__ + "../resources/img/new_sprite.49fa5134.png";